import { render } from "./AchievementView.vue?vue&type=template&id=7b2e68c4&scoped=true"
import script from "./AchievementView.vue?vue&type=script&lang=js"
export * from "./AchievementView.vue?vue&type=script&lang=js"

import "./AchievementView.vue?vue&type=style&index=0&id=7b2e68c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2e68c4"]])

export default __exports__